import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { ArrowRight } from "@/assets/icons/ds";
import { useSectionHeadingLevel } from "@/components/Layout/BaseLayouts/SectionHeadingLevel";
import { DeviceTile } from "@/components/Portal/components/PortalDeviceTiles/TilesGrid/Tiles/DeviceTile/DeviceTile.tsx";
import { portalRoutes } from "@/router/routes/portalRoutes";

const headingTag = { 2: "h2", 3: "h3" } as const;

export const PromoItemizedBillTile = () => {
  const { t } = useTranslation("portal");
  const Heading = headingTag[useSectionHeadingLevel()];

  return (
    <Link to={portalRoutes.documents.itemizedBills}>
      <DeviceTile dataTestid="promo-itemized-bill-tile">
        <div className="m-auto">
          <p className="text-left text-body-base leading-normal text-foreground-primary">
            {t("layout.tiles.promoItemizedBill.heading")}
          </p>
          <Heading className="mt-6 text-headline-md font-semibold leading-sm text-foreground-primary">
            {t("layout.tiles.promoItemizedBill.text")}
          </Heading>
        </div>
        <div className="button-wrapper">
          {/* Styled like a button, but a span: the whole tile is the link. */}
          <span className="button">
            <span className="manage">
              {t("layout.tiles.promoItemizedBill.activateNow")}
            </span>
            <ArrowRight className="size-6" />
          </span>
        </div>
      </DeviceTile>
    </Link>
  );
};
